<template>
  <li v-show="showNotifications">
    <a :href="glb.appUrl + 'notification/'" rel="nofollow" title="Notification">
      <i class="icon-bell f3"></i>
      <span v-if="getNotificationCount" class="menu-count bell-active notification"></span>
    </a>
  </li>
  <li v-show="!showNotifications && getFeed && getFeed.length > 0">
    <a :href="glb.appUrl + 'feed/'" rel="nofollow" title="Feed">
      <i class="icon-bell f3"></i>
      <span class="menu-count bell-active" v-if="getFeed.length"></span>
    </a>
  </li>
</template>

<script>
import { mapGetters } from "vuex";
import { checkAllowed } from '../../utilities/nojq/_notification.js';
import { getStorage } from '../../utilities/nojq/_localstorage.js';

export default {
  name: 'mvtHeaderNotifications',
  data() {
    return {
      showNotifications: false,
    }
  },
  computed: {
    ...mapGetters('glb', ['glb', 'getFeed']),
    getNotificationCount() {
      return this.glb.getSubscriptions?.length || 0;
    },
  },
  methods: {
    checkNotifications() {
      const records = getStorage('saveSearchRecord');
      this.showNotifications = checkAllowed() && records && records.length > 0;
    },
  },
  mounted() {
    this.checkNotifications();
  }
};
</script>